import { fixIPhoneApostrophes,
         formatDonorPhoneNumber,
         formatPostalCode,
         postCodeToUpperCase
 } from './common/utils.js';

const bindFormEvents = () => {
    // No 'Other' option
    $('select#Donation_Donor_Title', 'div.your-details').on('change', function (e) {
        if ($(this).val() === 'Other') {
            $('div.title-other', 'div.your-details').removeClass('js-hidden');
        } else {
            $('div.title-other:visible', 'div.your-details').addClass('js-hidden');
        }
    });

    // Show/hide phone field based on SMS consent checkbox
    const smsConsentCheckbox = document.getElementById('Donation_Donor_OptInText');
    const phoneUnderSms = document.getElementById('phone-under-sms-consent');

    if (smsConsentCheckbox && phoneUnderSms) {
        if (smsConsentCheckbox.checked) {
            phoneUnderSms.classList.remove('js-hidden');
        }

        smsConsentCheckbox.addEventListener('change', function () {
            if (this.checked) {
                phoneUnderSms.classList.remove('js-hidden');
                const phoneInput = phoneUnderSms.querySelector('input');
                if (phoneInput) phoneInput.focus();
            } else {
                phoneUnderSms.classList.add('js-hidden');
                const phoneInput = phoneUnderSms.querySelector('input');
                if (phoneInput) phoneInput.value = '';
            }
        });
    }

    postCodeToUpperCase();

    formatDonorPhoneNumber();

    formatPostalCode('#Donation_Donor_Address_PostalCode');

    fixIPhoneApostrophes();
}

/**
 * Usage: Main Donation Journey
 * Determines the appropriate CSS class to apply to the payment button container
 * based on the number of payment buttons present and their visibility status.
 * 
 * The function checks the number of elements with the class 'paymentButtonContainer'.
 * Depending on the count and the visibility of specific elements, it assigns a CSS
 * class ('twoButtons', 'threeButtons', or 'fourButtons') to the element with the
 * class 'paymentOuterCont'.
 */
const getPaymentButtons = () => {
    let className = '';
    let buttons = document.querySelectorAll('.paymentButtonContainer');

    if(buttons.length === 4) {
        if(document.querySelector('#divPay').classList.contains('hideContainer') || document.querySelector('.googlePayCont').classList.contains('hidden')) {
            className = 'threeButtons';
        }else {
            className = 'fourButtons';
        }
    }else if (buttons.length === 3) {
        className = 'threeButtons';
    }else if (buttons.length === 2) {
        className = 'twoButtons';
    }

    if (className && document.querySelector('.paymentOuterCont')) {
        document.querySelector('.paymentOuterCont').classList.add(className);
    }
}

/**
 * Usage: Main Donate - Regular Donation Journey
 * Enhances accessibility for direct debit error messages by making them focusable
 * and ensuring they are read by screen readers. When an error message with the
 * class 'dd-invalid-error' is present, it sets the tabindex to 0 and focuses on it.
 * Once the element loses focus, the tabindex attribute is removed.
 */
const handleDirectDebitErrorForScreenReader = () => {
    if ($('.dd-invalid-error').length) {
        $('.dd-invalid-error').attr('tabindex', 0);
        $('.dd-invalid-error').focus();
        $('.dd-invalid-error').on('blur', function () {
            $(this).removeAttr('tabindex');
        });
    }
}

export const initDonateForm = () => {
    bindFormEvents();
    getPaymentButtons();
    handleDirectDebitErrorForScreenReader();
};
